// A single condition line as stored on a document type or document
export interface ConditionLineType {
    uuid?: string;
    label: string;
    value: string;
}

// Creates a new empty condition line with a client uuid for the react key
export const createNewConditionLine = (uuid: string): ConditionLineType => ({
    uuid: uuid,
    label: '',
    value: '',
});

// Strips the client uuid so only the label and value are sent to the backend
export const serializeConditionLines = (lines: ConditionLineType[]): { label: string, value: string }[] => (
    lines.map(line => ({ label: line.label, value: line.value }))
);
